import React, { useState } from 'react';
import { Mail, User, Check, Loader2 } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { trackEvent } from '../../utils/analytics';
import { HubEmailFooter } from './HubBrand';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const hasHubAccess = (source, propertyId) =>
  !!localStorage.getItem(`${source}_access_${propertyId}`);

export const HubEmailGate = ({ source, propertyId, slug, prompt, buttonLabel, onUnlocked }) => {
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [optIn, setOptIn] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) return setError('Please enter your email');
    setSubmitting(true);
    try {
      const res = await fetch(`${API_URL}/api/public/guest-hub/capture-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email.trim(), first_name: firstName.trim(), source,
          property_id: propertyId, property_slug: slug, opt_in: optIn,
        }),
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(typeof data.detail === 'string' ? data.detail : 'Please enter a valid email');
      }
      trackEvent(`${source.replace('-', '_')}_email_captured`, { property_id: propertyId, opt_in: optIn });
      localStorage.setItem(`${source}_access_${propertyId}`, 'true');
      onUnlocked();
    } catch (err) {
      setError(err.message || 'Connection error. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card data-testid={`${source}-email-gate`} className="bg-slate-800/50 border-slate-700">
      <CardContent className="p-6">
        <p className="text-slate-300 text-center mb-6">{prompt}</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <User className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-500" />
            <Input data-testid={`${source}-gate-first-name`} type="text" placeholder="First name" value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className="pl-10 h-12 bg-slate-700 border-slate-600 text-white placeholder:text-slate-500" />
          </div>
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-500" />
            <Input data-testid={`${source}-gate-email`} type="email" placeholder="your@email.com" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="pl-10 h-12 bg-slate-700 border-slate-600 text-white placeholder:text-slate-500" />
          </div>
          <button type="button" data-testid={`${source}-gate-optin`} onClick={() => setOptIn(!optIn)}
            className="flex items-start gap-3 text-left">
            <span className={`w-5 h-5 rounded border flex-shrink-0 mt-0.5 flex items-center justify-center transition-colors ${optIn ? 'bg-amber-500 border-amber-500' : 'border-slate-500'}`}>
              {optIn && <Check className="h-3 w-3 text-slate-900" />}
            </span>
            <span className="text-slate-400 text-sm">Send me DC travel tips and exclusive guest offers.</span>
          </button>
          {error && <p data-testid={`${source}-gate-error`} className="text-red-400 text-sm text-center">{error}</p>}
          <Button data-testid={`${source}-gate-submit`} type="submit" disabled={submitting}
            className="w-full bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold py-6 text-lg">
            {submitting ? <Loader2 className="h-5 w-5 animate-spin" /> : buttonLabel}
          </Button>
        </form>
        <HubEmailFooter />
      </CardContent>
    </Card>
  );
};
